import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const RoleInput = ({name, label, onChange, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: 'care_guide_helpers_role_1',
    },
    {
      value: 2,
      label: 'care_guide_helpers_role_2',
    },
    {
      value: 3,
      label: 'care_guide_helpers_role_3',
    },
    /* {
      value: 4,
      label: 'care_guide_helpers_role_4',
    },
    {
      value: 5,
      label: 'care_guide_helpers_role_5',
    }, */
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={[
            {required: true, message: t('feedback_validation_required')},
          ]}
          {...props}
        >
          <Select disabled={disabled} onChange={onChange}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default RoleInput;
